<template>
  <q-dialog v-model="add">
    <q-card>
      <q-form @submit="onSubmit" ref="myForm" class="flexbox">
        <div class="q-pa-md">
          <div class="row q-col-gutter-md">
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">Vehicle*</span>
              <q-select
                outlined
                color="grey-7"
                label-color="grey-7"
                lazy-rules
                disable
                style="overflow: hidden !important"
                :option-label="
                  vehicle =>
                    vehicle.brand && vehicle.brand.name
                      ? `${vehicle.brand.name}#${vehicle.model.name}#${vehicle.unit}`
                      : ''
                "
                v-model="selectedVehicle"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:prepend>
                  <q-icon name="fas fa-user-tie" size="16px" color="grey-7"></q-icon>
                </template>
              </q-select>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <span class="label-input">Mileage*</span>
              <q-input
                type="number"
                outlined
                v-model="millage"
                lazy-rules
                :rules="[val => (val !== null && val !== '') || 'Please type mils value']"
              ></q-input>
            </div>
            <div class="mt-5 flex-end q-gutter-xs">
              <q-btn :loading="loading" label="Save" :disable="loading" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  data() {
    return {
      loading: false,
      price: '',
      millage: ''
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const body = {
          vehicle: this.selectedVehicle.id,
          mileage: parseFloat(this.millage),
          date: new Date().toISOString().slice(0, 10)
        }
        const { data } = await axios.put('vehicle-mileage-record', body)
        this.$store.commit('millage/ADD_MILLAGE', data.data)
        this.$q.notify({
          message: data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        this.add = false
      } catch (error) {
        const { message } = error.response.data
        this.$q.notify({
          message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    selectedVehicle() {
      return this.$store.state.millage.selectedVehicle
    },
    add: {
      get() {
        return this.$store.state.millage.add
      },
      set(val) {
        this.$store.commit('millage/SET_ADD', val)
      }
    }
  }
}
</script>
